import React from 'react'
import config from 'config'
import { get } from 'lodash'

import {
  Activity,
  ActivityFiles,
  Badges,
  ActivityLogs,
  ActivityOverview
}
  from 'containers/pages'

const urlPrefix = `${config.publicPath}/dashboard/awards/:awardId/activity/:activityId`

export default [
  {
    path: `${urlPrefix}`,
    component: props => (
      <Activity
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: [
      {
        path: `${urlPrefix}/logs`,
        exact: true,
        component: props => (
          <ActivityLogs
            params={get(props, 'match.params', {})}
            {...props}
          />
        )
      },
      {
        path: `${urlPrefix}/overview`,
        exact: true,
        component: props => (
          <ActivityOverview
            params={get(props, 'match.params', {})}
            {...props}
          />
        )
      },
      {
        path: `${urlPrefix}/files`,
        exact: true,
        component: props => (
          <ActivityFiles
            params={get(props, 'match.params', {})}
            {...props}
          />
        )
      },
      {
        path: `${urlPrefix}/badges`,
        exact: true,
        component: props => (
          <Badges
            params={get(props, 'match.params', {})}
            {...props}
          />
        )
      }
    ]
  }
]
